// AUT-33 — configuration web-parent du mécanisme partagé AUT-32
// (`packages/ui/src/auth/invitationContinuation.ts`) : deux types d'invitation, donc
// toujours explicites dans l'URL (`?invitation=parent|guardian&invitationToken=…`),
// chacun renvoyé sur SA page d'acceptation après `/register` ou `/login`.
import { createInvitationContinuation } from '@monecolier/ui';

export type ParentAppInvitationKind = 'parent' | 'guardian';

export const invitationContinuation = createInvitationContinuation<ParentAppInvitationKind>({
  acceptPaths: {
    // AUT-18 : parent invité par l'école (élève importé en masse).
    parent: '/accept-parent-invitation',
    // PAR-04 : co-parent invité par un parent.
    guardian: '/accept-guardian-invitation',
  },
});
